module.exports = __webpack_public_path__ + "img/seventyoff.2c4e8547.png";